import { ButtonHTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface TabButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  isActive: boolean;
  children: ReactNode;
  variant?: 'default' | 'gradient';
}

export const TabButton = ({ 
  isActive, 
  children, 
  className,
  variant = 'default',
  ...props 
}: TabButtonProps) => {
  if (variant === 'gradient') {
    return (
      <button
        style={{
          background: isActive 
            ? 'linear-gradient(135deg, hsl(var(--primary)) 0%, hsl(var(--primary) / 0.8) 100%)'
            : 'hsl(var(--primary) / 0.1)',
          color: isActive ? 'hsl(var(--primary-foreground))' : 'hsl(var(--primary) / 0.6)',
          border: isActive ? '1px solid hsl(var(--primary) / 0.3)' : '1px solid hsl(var(--border) / 0.5)',
          boxShadow: isActive ? '0 4px 12px hsl(var(--primary) / 0.15)' : 'none'
        }}
        className={cn(
          "px-4 sm:px-5 py-2 sm:py-2.5 rounded-xl text-xs sm:text-sm font-semibold transition-all duration-300 hover:scale-[1.02]",
          !isActive && "hover:bg-[hsl(var(--primary)/0.2)]",
          className
        )}
        {...props}
      >
        {children}
      </button>
    );
  }

  return (
    <button
      className={cn(
        "px-3 sm:px-4 py-2 rounded-lg text-xs sm:text-sm font-medium transition-all whitespace-nowrap",
        isActive
          ? 'bg-primary text-primary-foreground shadow-sm'
          : 'bg-primary/10 text-primary/60 hover:bg-primary/20 hover:text-primary/80',
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
};
